module.exports = __webpack_public_path__ + "media/images/ic_shield-0e72b9e3e0d5b26e8e5636b573270972.svg";